module.exports = __webpack_public_path__ + "static/angie_jazz-f1c2dd186ddf4fe8515f716d28c6ceab.png";